import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { OutgoingPostbackTrigger } from "types/enums";

export const useTriggerSelectOptions = () => {
    const { t } = usePaldockTranslation("forms.general-options");

    const options = Object.entries(OutgoingPostbackTrigger).map(([, value]) => ({
        label: t(`outgoing_postback_trigger.${value}`),
        value: value,
    }));

    return { options, loading: false, error: null };
};
